export default __webpack_public_path__ + "static/media/levelTest-Illustration05.5575eaa2.jpg";